import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboardIcon, FileTextIcon, SendIcon, SettingsIcon, XIcon } from 'lucide-react';
interface SidebarProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}
const Sidebar = ({
  isOpen,
  setIsOpen
}: SidebarProps) => {
  const navItems = [{
    name: 'E-Pub: Dashboard',
    path: '/',
    icon: <LayoutDashboardIcon size={20} data-id="element-56" />
  }, {
    name: 'Templates',
    path: '/templates',
    icon: <FileTextIcon size={20} data-id="element-57" />
  }, {
    name: 'Newsletters',
    path: '/newsletters',
    icon: <SendIcon size={20} data-id="element-58" />
  }, {
    name: 'Settings',
    path: '/settings',
    icon: <SettingsIcon size={20} data-id="element-59" />
  }];
  return <>
      {/* Mobile sidebar backdrop */}
      {isOpen && <div className="fixed inset-0 z-20 bg-black bg-opacity-50 lg:hidden" onClick={() => setIsOpen(false)} data-id="element-60" />}
      {/* Sidebar */}
      <aside className={`fixed inset-y-0 left-0 z-30 w-64 transform bg-white shadow-lg transition-transform duration-300 ease-in-out lg:static lg:translate-x-0 ${isOpen ? 'translate-x-0' : '-translate-x-full'}`} data-id="element-61">
        <div className="flex h-16 items-center justify-between border-b border-secondary-200 px-4" data-id="element-62">
          <div className="flex items-center space-x-2" data-id="element-63">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wCTiR9SpwfFxdHPvrQ4dbd/ud_logo.png" alt="ekseba Uddokta" className="h-10 w-auto" data-id="element-64" />
          </div>
          <button className="rounded-md p-1 text-secondary-500 hover:bg-secondary-100 lg:hidden" onClick={() => setIsOpen(false)} data-id="element-65">
            <XIcon size={20} data-id="element-66" />
          </button>
        </div>
        <nav className="mt-4 px-2" data-id="element-67">
          <div className="space-y-1" data-id="element-68">
            {navItems.map(item => <NavLink key={item.path} to={item.path} className={({
            isActive
          }) => `flex items-center rounded-md px-3 py-2 text-sm font-medium transition-colors ${isActive ? 'bg-primary-50 text-primary-600' : 'text-secondary-700 hover:bg-secondary-100'}`} data-id="element-69">
                <span className="mr-3" data-id="element-70">{item.icon}</span>
                <span data-id="element-71">{item.name}</span>
              </NavLink>)}
          </div>
          <div className="mt-8 border-t border-secondary-200 pt-4" data-id="element-72">
            <div className="flex items-center px-3 py-2" data-id="element-73">
              <div className="h-8 w-8 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center" data-id="element-74">
                <span className="text-sm font-medium" data-id="element-75">SA</span>
              </div>
              <div className="ml-3" data-id="element-76">
                <p className="text-sm font-medium text-secondary-900" data-id="element-77">
                  Super Admin
                </p>
                <p className="text-xs text-secondary-500" data-id="element-78">admin@ekseba.com</p>
              </div>
            </div>
          </div>
        </nav>
      </aside>
    </>;
};
export default Sidebar;